import React from 'react'
import styled from 'styled-components'

import { GradientLink } from '@/components/ui/gradient-link'
import ShapesImage from '@/assets/images/shapes/intro.svg'
import { mobile } from '@/utils/media-query'

import { GiphyTextPlayGround } from './giphy-text-playground'
import { Section } from './section'
import { Shapes } from './shapes'

const StyledSection = styled(Section)`
  && {
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    @media ${mobile.query} {
      flex-direction: column-reverse;
    }
  }
`

const TextColumn = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 12px;
  width: 285px;

  @media ${mobile.query} {
    align-items: flex-end;
    margin: 32px 0 50px;
    text-align: right;
  }
`

const Title = styled.h3`
  margin-bottom: 16px;

  @media ${mobile.query} {
    font-size: 24px;
  }
`

const Description = styled.p`
  margin-bottom: 18px;
`

const Lines = styled(Shapes)`
  top: initial;
  left: initial;
  height: 300px;
  width: 300px;
  transform: translate(-250px, 260px);

  &::before {
    background-position-y: -770px;
    background-position-x: -230px;
  }
`

export const GiphyTextSection: React.FC = () => {
  return (
    <StyledSection>
      <TextColumn>
        <Title>Seamlessly Create Content for Expression</Title>
        <Description>
          Use the Text endpoint through the GIPHY SDK to deliver customized animated stickers in
          real time!
        </Description>
        <GradientLink text="Open in Docs" url="/docs/sdk#content-types" />
      </TextColumn>
      <Lines source={ShapesImage} />
      <GiphyTextPlayGround />
    </StyledSection>
  )
}
